module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "workbench"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.optionsByCostAsc), function(option, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(option.optionNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(option.serviceProviderName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(option.distance + ' ' + (option.distanceType || '')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(option.duration + ' ' + option.durationType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(option.reportingCurrencyRate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(option.providerQuality || ''))]), _vm._v(" "), _c('td', [(option.details[0].rateIdentifier === _vm.currentSelection.details[0].rateIdentifier) ? _c('div', {
      staticClass: "btn btn-default sq disabled"
    }, [_vm._v("\n            Selected\n          ")]) : _c('div', [_c('div', {
      staticClass: "btn btn-primary sq",
      on: {
        "click": function($event) {
          return _vm.$emit('comparison', option.optionNumber)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('div', {
      staticClass: "btn btn-success sq",
      on: {
        "click": function($event) {
          return _vm.makeChoice(option)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Option")]), _vm._v(" "), _c('th', [_vm._v("Provider")]), _vm._v(" "), _c('th', [_vm._v("Distance")]), _vm._v(" "), _c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Quality")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8c09284"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/WorkBench.vue
// module id = 2290
// module chunks = 1